export default "/images/topdanmark-min.png?30103b50bc03d12c776588def081c406";